import { GoogleOAuthProvider } from "@react-oauth/google";
import { AppFooter } from "app/AppFooter";
import { Logo } from "components/Logo";
import type { PropsWithChildren } from "react";
import { config } from "utils/config";
import "../auth.css";
import { AuthBrandPanel } from "./Welcome";

export function AuthPage(props: PropsWithChildren) {
	return (
		<GoogleOAuthProvider clientId={config.googleClient.id}>
			<div className="auth-shell">
				<AuthBrandPanel />
				<main className="auth-main">
					<div className="auth-main__inner">
						<div className="auth-mobile-logo">
							<Logo width={140} />
						</div>
						<div className="auth-main__content">{props.children}</div>
					</div>
					<AppFooter />
				</main>
			</div>
		</GoogleOAuthProvider>
	);
}
